(function () {
  function initSmartEventSetups(section) {
    if (!section || section.dataset.smartEventSetupsReady === 'true') return;
    section.dataset.smartEventSetupsReady = 'true';

    var gallery = section.querySelector('[data-smart-event-setups-gallery]');
    var rows = Array.prototype.slice.call(section.querySelectorAll('[data-smart-event-setups-row]'));
    var button = section.querySelector('[data-smart-event-setups-more]');
    var mobileQuery = window.matchMedia('(max-width: 749px)');

    function getGap() {
      var value = getComputedStyle(section).getPropertyValue('--ses-gap');
      return parseFloat(value) || 12;
    }

    function clearDesktopSizes() {
      rows.forEach(function (row) {
        Array.prototype.slice.call(row.querySelectorAll('[data-smart-event-setups-tile]')).forEach(function (tile) {
          tile.style.width = '';
          tile.style.height = '';
        });
      });
    }

    function layoutRows() {
      if (mobileQuery.matches) {
        clearDesktopSizes();
        return;
      }

      var gap = getGap();

      rows.forEach(function (row) {
        var tiles = Array.prototype.slice.call(row.querySelectorAll('[data-smart-event-setups-tile]'));
        if (!tiles.length) return;

        var rowWidth = row.clientWidth;
        if (!rowWidth) return;

        var ratioSum = tiles.reduce(function (sum, tile) {
          var ratio = parseFloat(tile.getAttribute('data-ratio'));
          return sum + (ratio > 0 ? ratio : 1);
        }, 0);

        var totalGap = gap * Math.max(0, tiles.length - 1);
        var height = (rowWidth - totalGap) / ratioSum;

        tiles.forEach(function (tile) {
          var ratio = parseFloat(tile.getAttribute('data-ratio'));
          ratio = ratio > 0 ? ratio : 1;
          tile.style.width = (height * ratio) + 'px';
          tile.style.height = height + 'px';
        });
      });
    }

    var resizeTimer;
    function requestLayout() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(layoutRows, 80);
    }

    layoutRows();
    window.addEventListener('resize', requestLayout);

    Array.prototype.slice.call(section.querySelectorAll('img')).forEach(function (img) {
      if (!img.complete) {
        img.addEventListener('load', layoutRows, { once: true });
      }
    });

    if (button && gallery) {
      var extras = gallery.querySelectorAll('.smart-event-setups__tile--mobile-extra');
      if (!extras.length) {
        button.style.display = 'none';
      }

      button.addEventListener('click', function () {
        gallery.classList.toggle('is-expanded');
        var expanded = gallery.classList.contains('is-expanded');
        button.textContent = expanded ? button.dataset.lessText : button.dataset.moreText;
      });
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event && event.target && event.target.id === section.id) {
        layoutRows();
      }
    });
  }

  function initAllSmartEventSetups() {
    Array.prototype.slice.call(document.querySelectorAll('[data-smart-event-setups]')).forEach(initSmartEventSetups);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSmartEventSetups);
  } else {
    initAllSmartEventSetups();
  }
})();
